<template>
  <v-app id="inspire">
    <h2 class="ma-3">Shooter's Journal Dashboard</h2>
    <v-container fluid>
      <v-row dense>
        <v-col cols="12" md="3" xl="2">
          <v-card elevation="4" class="pa-3 mx-3 dashboard-item">
            <div class="pa-3 text-h6">Confirmed users</div>
            <v-card-title class="text-h2"
              ><v-icon x-large color="primary" class="mr-3"
                >mdi-account-check</v-icon
              >{{ userCount }}</v-card-title
            >
            <v-card-subtitle class="text-subtitle-1 mt-3">
              <div>
                <strong>{{ userCountNewLastWeek }}</strong> new last week
              </div>
              <div>
                <strong>{{ userCountNewLastMonth }}</strong> new last month
              </div>
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" xl="2">
          <v-card elevation="4" class="pa-3 mx-3 dashboard-item">
            <div class="pa-3 text-h6">Sessions</div>
            <v-card-title class="text-h2"
              ><v-icon x-large color="primary" class="mr-3"
                >mdi-calendar-check</v-icon
              >{{ sessionCount }}</v-card-title
            >
            <v-card-subtitle class="text-subtitle-1 mt-3">
              <div>
                <strong>{{ sessionCountNewLastWeek }} </strong>new last week
              </div>
              <div>
                <strong>{{ sessionCountNewLastMonth }} </strong>new last month
              </div>
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" xl="2">
          <v-card elevation="4" class="pa-3 mx-3 dashboard-item">
            <div class="pa-3 text-h6">Instances</div>
            <v-card-title class="text-h2"
              ><v-icon x-large color="primary" class="mr-3"
                >mdi-format-list-numbered</v-icon
              >{{ instanceCount }}</v-card-title
            >
            <v-card-subtitle class="text-subtitle-1 mt-3">
              <div>
                <strong>{{ instanceCountNewLastWeek }} </strong>new last week
              </div>
              <div>
                <strong>{{ instanceCountNewLastMonth }} </strong>new last month
              </div>
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" xl="2">
          <v-card elevation="4" class="pa-3 mx-3 dashboard-item">
            <div class="pa-3 text-h6">Subscriptions</div>
            <v-card-title class="text-h2"
              ><v-icon x-large color="primary" class="mr-3"
                >mdi-cash-sync</v-icon
              >{{ subscriptionsCount }}</v-card-title
            >
            <v-card-subtitle class="text-subtitle-1 mt-3">
              <div>
                <strong>{{ subscriptionsCountNewLastWeek }} </strong>new last
                week
              </div>
              <div>
                <strong>{{ subscriptionsCountNewLastMonth }} </strong>new last
                month
              </div>
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" xl="9">
          <v-card elevation="4" class="pa-3 mx-3">
            <div class="pa-3 text-h6">Last 10 registered instances</div>
            <v-list class="pa-0 ma-0">
              <v-list-item
                v-for="(instance, index) in lastTenInstances"
                :key="instance.id"
                two-line
              >
                <v-list-item-avatar class="d-none d-md-block">
                  {{ index + 1 }}
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{
                    instance.jsonData.shootingProgramStatus.shootingProgramName
                  }}</v-list-item-title>
                  <v-list-item-subtitle
                    ><strong>{{ GetName(instance) }}</strong>
                    {{
                      new Date(instance.createdAt).toDateString()
                    }}</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { USER_QUERY_GET_COUNT } from '../../graphql/authenticationQueries';
import {
  RESULT_QUERY_GET_INSTANCE_COUNT,
  RESULT_QUERY_GET_SESSION_COUNT,
  RESULT_QUERY_GET_INSTANCES,
} from '../../graphql/resultQueries';

import { PAYMENT_QUERY_GET_ACTIVE_SHOOTERS_JOURNAL_SUBSCRIPTIONS_COUNT } from '../../graphql/paymentQueries';

export default {
  data() {
    return {
      userCount: 0,
      userCountNewLastWeek: 0,
      userCountNewLastMonth: 0,
      sessionCount: 0,
      sessionCountNewLastWeek: 0,
      sessionCountNewLastMonth: 0,
      instanceCount: 0,
      instanceCountNewLastWeek: 0,
      instanceCountNewLastMonth: 0,
      lastTenInstances: [],
      subscriptionsCountResponse: null,
      subscriptionsCountNewLastWeekResponse: null,
      subscriptionsCountNewLastMonthResponse: null,
    };
  },
  methods: {
    GetName(instance) {
      if (!instance.jsonData.shootingProgramStatus.shooter)
        return 'Unknown shooter';
      return (
        instance.jsonData.shootingProgramStatus.shooter.firstName +
        ' ' +
        instance.jsonData.shootingProgramStatus.shooter.lastName
      );
    },
  },
  computed: {
    subscriptionsCount() {
      const res = this.subscriptionsCountResponse;
      if (!res || res.status !== 'OK') return 'N/A';
      return res.data;
    },
    subscriptionsCountNewLastWeek() {
      const res = this.subscriptionsCountNewLastWeekResponse;
      if (!res || res.status !== 'OK') return 'N/A';
      return res.data;
    },
    subscriptionsCountNewLastMonth() {
      const res = this.subscriptionsCountNewLastMonthResponse;
      if (!res || res.status !== 'OK') return 'N/A';
      return res.data;
    },
  },
  apollo: {
    userCount: {
      query: USER_QUERY_GET_COUNT,
      variables: { onlyConfirmed: true },
      update: (data) => data.getUserCount,
      pollInterval: 60000,
    },
    userCountNewLastWeek: {
      query: USER_QUERY_GET_COUNT,
      variables: { onlyConfirmed: true, createdLastNumberOfDays: 7 },
      update: (data) => data.getUserCount,
      pollInterval: 60000,
    },
    userCountNewLastMonth: {
      query: USER_QUERY_GET_COUNT,
      variables: { onlyConfirmed: true, createdLastNumberOfDays: 30 },
      update: (data) => data.getUserCount,
      pollInterval: 60000,
    },
    sessionCount: {
      client: 'resultClient',
      query: RESULT_QUERY_GET_SESSION_COUNT,
      variables: { includeEmpty: false },
      update: (data) => data.getSessionCount,
      pollInterval: 60000,
    },
    sessionCountNewLastWeek: {
      client: 'resultClient',
      query: RESULT_QUERY_GET_SESSION_COUNT,
      variables: { createdLastNumberOfDays: 7 },
      update: (data) => data.getSessionCount,
      pollInterval: 60000,
    },
    sessionCountNewLastMonth: {
      client: 'resultClient',
      query: RESULT_QUERY_GET_SESSION_COUNT,
      variables: { createdLastNumberOfDays: 30 },
      update: (data) => data.getSessionCount,
      pollInterval: 60000,
    },
    instanceCount: {
      client: 'resultClient',
      query: RESULT_QUERY_GET_INSTANCE_COUNT,
      update: (data) => data.getInstanceCount,
      pollInterval: 60000,
    },
    instanceCountNewLastWeek: {
      client: 'resultClient',
      query: RESULT_QUERY_GET_INSTANCE_COUNT,
      variables: { createdLastNumberOfDays: 7 },
      update: (data) => data.getInstanceCount,
      pollInterval: 60000,
    },
    instanceCountNewLastMonth: {
      client: 'resultClient',
      query: RESULT_QUERY_GET_INSTANCE_COUNT,
      variables: { createdLastNumberOfDays: 30 },
      update: (data) => data.getInstanceCount,
      pollInterval: 60000,
    },
    subscriptionsCountResponse: {
      client: 'paymentClient',
      query: PAYMENT_QUERY_GET_ACTIVE_SHOOTERS_JOURNAL_SUBSCRIPTIONS_COUNT,
      update: (data) => data.getActiveShootersJournalSubscriptionsCount,
      pollInterval: 60000,
    },
    subscriptionsCountNewLastWeekResponse: {
      client: 'paymentClient',
      query: PAYMENT_QUERY_GET_ACTIVE_SHOOTERS_JOURNAL_SUBSCRIPTIONS_COUNT,
      variables: { createdLastNumberOfDays: 7 },
      update: (data) => data.getActiveShootersJournalSubscriptionsCount,
      pollInterval: 60000,
    },
    subscriptionsCountNewLastMonthResponse: {
      client: 'paymentClient',
      query: PAYMENT_QUERY_GET_ACTIVE_SHOOTERS_JOURNAL_SUBSCRIPTIONS_COUNT,
      variables: { createdLastNumberOfDays: 30 },
      update: (data) => data.getActiveShootersJournalSubscriptionsCount,
      pollInterval: 60000,
    },
    lastTenInstances: {
      client: 'resultClient',
      query: RESULT_QUERY_GET_INSTANCES,
      variables: { limit: 10 },
      update: (data) => data.getInstances,
      pollInterval: 60000,
    },
  },
};
</script>

<style scoped>
@media only screen and (max-width: 1000px) {
  #editTemplateRow {
    width: 10%;
  }
}

.dashboard-item {
  min-height: 300px;
}
</style>
